import {
  InternalError,
  PublicError,
  TaggedError,
} from "@/domain/errors/common";

const ERROR_MESSAGES = {
  AUTH_NOT_ACCOUNT_FOUND: "No se encontró una cuenta registrada con ese correo",
  AUTH_INVALID_LOGIN: "Ha ocurrido un error al intentar iniciar sesión",
  AUTH_LOGOUT_ERROR: "Ha ocurrido un error al intentar cerrar sesión",
  AUTH_SESSION_NOT_FOUND: "No se encontró una sesión activa",
  AUTH_EMAIL_VERIFICATION_ERROR:
    "Ha ocurrido un error al verificar el correo electrónico",
  AUTH_REGISTRATION_ERROR: "Ha ocurrido un error al intentar registrarse",
  AUTH_INVALID_CREDENTIALS: "Contraseña o correo electrónico incorrectos",
  AUTH_ADDRESS_ALREADY_IN_USE: "Correo electrónico ya registrado",
  AUTH_USER_NOT_ENABLED: "Falta verificar el correo electrónico",
  AUTH_INVALID_VERIFICATION_CODE: "Código de verificación inválido",
  AUTH_EXPIRED_VERIFICATION_CODE: "El código de verificación ha expirado",
  AUTH_EMAIL_VALIDATION_ERROR:
    "El correo electrónico proporcionado no contiene el formato correcto",
};

class AuthLoginError extends PublicError {
  constructor() {
    super(ERROR_MESSAGES.AUTH_INVALID_LOGIN);
  }
}

class AuthNotFoundError extends PublicError {
  constructor() {
    super(ERROR_MESSAGES.AUTH_NOT_ACCOUNT_FOUND);
  }
}

class AuthLogoutError extends InternalError {
  constructor() {
    super(ERROR_MESSAGES.AUTH_LOGOUT_ERROR);
  }
}

class AuthSessionNotFoundError extends PublicError {
  constructor() {
    super(ERROR_MESSAGES.AUTH_SESSION_NOT_FOUND);
  }
}

class AuthEmailVerificationError extends PublicError {
  constructor() {
    super(ERROR_MESSAGES.AUTH_EMAIL_VERIFICATION_ERROR);
  }
}

class AuthRegistrationError extends PublicError {
  constructor() {
    super(ERROR_MESSAGES.AUTH_REGISTRATION_ERROR);
  }
}

class AuthInvalidCredentialsError extends PublicError {
  constructor() {
    super(ERROR_MESSAGES.AUTH_INVALID_CREDENTIALS);
  }
}

class AuthAddressAlreadyInUseError extends PublicError {
  constructor() {
    super(ERROR_MESSAGES.AUTH_ADDRESS_ALREADY_IN_USE);
  }
}

class AuthUserNotEnabledError extends PublicError {
  constructor() {
    super(ERROR_MESSAGES.AUTH_USER_NOT_ENABLED);
  }
}

class AuthInvalidVerificationCodeError extends PublicError {
  constructor() {
    super(ERROR_MESSAGES.AUTH_INVALID_VERIFICATION_CODE);
  }
}

class AuthExpiredVerificationCodeError extends PublicError {
  constructor() {
    super(ERROR_MESSAGES.AUTH_EXPIRED_VERIFICATION_CODE);
  }
}

class AuthEmailValidationError extends PublicError {
  constructor() {
    super(ERROR_MESSAGES.AUTH_EMAIL_VALIDATION_ERROR);
  }
}

class TaggedAuthRefreshTokenError extends TaggedError("AuthRefreshTokenError") {
  mustInvalidateSession = false;
  constructor(params: { mustInvalidateSession: boolean }) {
    super({
      message: "Error al refrescar el token de autenticación",
      cause: undefined,
    });
    this.mustInvalidateSession = params.mustInvalidateSession;
  }
}

export {
  TaggedAuthRefreshTokenError,
  AuthLoginError,
  AuthNotFoundError,
  AuthLogoutError,
  AuthSessionNotFoundError,
  AuthEmailVerificationError,
  AuthRegistrationError,
  AuthInvalidCredentialsError,
  AuthAddressAlreadyInUseError,
  AuthUserNotEnabledError,
  AuthInvalidVerificationCodeError,
  AuthExpiredVerificationCodeError,
  AuthEmailValidationError,
};
